function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#4dbfd9",
  d: "M37.69 88.52h9.94l-.49-25.58h-8.66zm19.33 0h9.93l-.49-25.58H57.8z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  stroke: "#222",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  d: "M75.8 11.68v75.5m5.53-6.79H70.75"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M75.8 14.7c.97.35 6.85 3.24 6.86 6.01.01 2.66-2.06 2.59-2.06 2.59",
  fill: "none",
  stroke: "#222",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeMiterlimit: 10
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  stroke: "#222",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  d: "M24.2 11.68v75.5m-5.53-6.79h10.58"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.2 14.7c-.97.35-6.85 3.24-6.86 6.01-.01 2.66 2.06 2.59 2.06 2.59",
  fill: "none",
  stroke: "#222",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeMiterlimit: 10
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M36.47 48.51L35.45 86.5h9.76l-.56-42.98.55-28.82s-.86-3.23-4.88-3.23-4.88 3.23-4.88 3.23l1.03 27.83m18.98 18.84l-.68 25.13h9.76l-.56-42.98.56-28.82s-.86-3.23-4.88-3.23-4.88 3.23-4.88 3.23l.89 29.13-.18 9.83",
  fill: "none",
  stroke: "#222",
  strokeWidth: 3,
  strokeMiterlimit: 10
});

var _ref7 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 40.32,
  cy: 51.61,
  r: 1.23,
  fill: "#222"
});

var _ref8 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 59.65,
  cy: 51.61,
  r: 1.23,
  fill: "#222"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#222",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  d: "M32.54 63.22l7.78-7.47 7.85 7.47m3.67 0l7.78-7.47 7.84 7.47"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#222",
  strokeWidth: 2,
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  d: "M36 42.53l4.32 4.94 4.14-4.94zm19.42 0l4.32 4.94 4.14-4.94zM36 60.5h9.31m10.11 0h9.31"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 100 100"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

export default __webpack_public_path__ + "static/media/ski.ef1ad699.svg";
export { SvgComponent as ReactComponent };